import React from "react";
import "./footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      Copyright &#169; 2023 Mohd Belal. All right received.
    </footer>
  );
};

export default Footer;
